import React, { FC } from 'react';
import { checkIfCategoryIsSelected, limitVisibility } from './categoriesUtils';
import { CategoriesNodeItem, CategoriesToggler } from './CategoriesLib';
import { CategoryType } from '../../../search.types';

type Props = {
  children?: (cat: CategoryType) => React.ReactNode;
  items?: CategoryType[];
  panes: {
    [s: string]: boolean;
  };
  aggregationsPaths: string[];
  selectedPanes: string[];
  path: Array<string>;
  className?: string;
  displayedItemCount: number;
  onSelect: Function;
  onExpand: Function;
  onToggleSeeMore: Function;
};

export const CategoriesNode: FC<Props> = ({
  children = () => null,
  items = [],
  panes,
  aggregationsPaths,
  path,
  onSelect,
  className,
  displayedItemCount,
  onToggleSeeMore,
  onExpand,
  selectedPanes,
}) => {
  const key = path[path.length - 1];

  if (items.length === 0) return null;

  const filteredItems = items.filter(
    limitVisibility(panes, aggregationsPaths, path, displayedItemCount),
  );

  return (
    <div className={className}>
      {filteredItems.map(subCategory => {
        const paths = [...path, subCategory.key];
        const isSelected = checkIfCategoryIsSelected(paths, aggregationsPaths);
        const isExpanded = checkIfCategoryIsSelected(paths, selectedPanes);
        return (
          <CategoriesNodeItem
            key={subCategory.key}
            category={subCategory}
            onSelect={onSelect(path, subCategory)}
            isSelected={isSelected}
            onExpand={onExpand(path, subCategory)}
            isExpanded={isExpanded}
          >
            {children(subCategory)}
          </CategoriesNodeItem>
        );
      })}
      {items.length > displayedItemCount && (
        <CategoriesToggler
          onToggle={onToggleSeeMore(path)}
          isOpen={panes[key]}
        />
      )}
    </div>
  );
};
